import React, { useState } from "react";
import "./sideMenu.css";

import { NavLink, Link } from "react-router-dom";

import { useAuth } from "../../../contexts/AuthContext";
import HamburgerMenu from "../../commonComponents/HamburgerMenu";

export default function SideMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { logout } = useAuth();

  function handleLogout() {
    logout();
  }

  function handleToggle() {
    setIsMenuOpen((val) => !val);
  }

  return (
    <>
      <div className="side-menu-toggle" onClick={handleToggle}>
        <HamburgerMenu isOpen={isMenuOpen} />
      </div>
      <div
        className={`dashboard-sidemenu ${isMenuOpen ? "sidemenu-active" : ""}`}
      >
        <div className="sidemenu-vertical-line"></div>
        <div className="sidemenu-menu">
          <ul className="menu-list">
            <li>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-menu-item menu-list-item"
                    : "menu-list-item"
                }
                onClick={handleToggle}
                to="/dashboard/"
              >
                <span>اطلاعات کاربری</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-menu-item menu-list-item"
                    : "menu-list-item"
                }
                onClick={handleToggle}
                to="/dashboard/offers"
              >
                <span>تخفیف های شما</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-menu-item menu-list-item"
                    : "menu-list-item"
                }
                onClick={handleToggle}
                to="/dashboard/orders"
              >
                <span>سفارشات شما</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-menu-item menu-list-item"
                    : "menu-list-item"
                }
                onClick={handleToggle}
                to="/dashboard/password-reset"
              >
                <span>تغییر رمز عبور</span>
              </NavLink>
            </li>
            <li>
              <Link className="menu-list-item" to="/">
                <span>بازگشت به فروشگاه</span>
              </Link>
            </li>
            <li>
              <Link onClick={handleLogout} className="menu-list-item" to="/">
                <span>خروج</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
